
import { BASE_URL, SERVICE_API, DO_THE_RACE, FINISH_THE_RACE, F1_GRILL, LOCAL_IP } from '../utils/Const';
import config from '../../config';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';
import socketService from '../sockets/SocketService';
import { store } from '../..';
// const CryptoJS = require("crypto-js");
const MAX_REQUEST_SIZE = 20 * 1024 * 1024; // 20 MiB
const REQUEST_WARNING_INTERVAL = 30000; // 30s
const RB19_Chequito_BB_LOGIN = 'R2D2-IS-THE-SHIT-117';
const clientDate = moment(new Date()).format('YYYYMMDD HH:MM:ss');


export class ApiClient {
    static sessionExpiredCallback;

    static getInstance(baseUrl) {
        return createApiClient(baseUrl);
    }

    static setSessionExpiredCallback(callback) {
        ApiClient.sessionExpiredCallback = callback;
    }

    constructor(baseUrl = BASE_URL) {
        this.baseUrl = baseUrl;
    }

    async getDBName() {
        const url = this.getEndpointUrl(SERVICE_API.getDBName);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            },
            'token'
        );
        return response;
    }

    async login(data) {
        const url = this.getEndpointUrl(SERVICE_API.login);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: await DO_THE_RACE(JSON.stringify(data), RB19_Chequito_BB_LOGIN),
            },
            'token'
        );
        return response;
    }

    async validateTwoSteps(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateTwoSteps);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
            'token'
        );
        return response;

    }

    async createTXT(data, table) {
        const url = this.getEndpointUrl(SERVICE_API.createTXT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data, table }),
            }
        );
        return response;

    }

    async getCitibanamexDocsDetails(data, table) {
        const url = this.getEndpointUrl(SERVICE_API.getCitibanamexDocsDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data, table }),
            }
        );
        return response;
    }

    async uploadPaymentFile(file) {
        const url = this.getEndpointUrl(SERVICE_API.uploadPaymentFile);
        const formData = new FormData();
        formData.append('file', file);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                body: formData
            }
        );
        return response;
    }

    async processPaymentFiles(data) {
        const url = this.getEndpointUrl(SERVICE_API.processPaymentFiles);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }
        );
        return response;
    }

    async downloadPaymentFile(data) {
        const url = this.getEndpointUrl(SERVICE_API.downloadPaymentFile);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }
        );
        return response;
    }

    async getPartnersCitibanamex(card) {
        const url = this.getEndpointUrl(SERVICE_API.getPartnersCitibanamex + '/' + card);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            },
        );
        return response;
    }

    async validateChangePassword(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateChangePassword);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
            'token'
        );
        return response;

    }

    async getVendors(search) {
        const url = this.getEndpointUrl(SERVICE_API.getVendors);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ search })
            },

        );
        return response;
    }
    async getSuggestionDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSuggestionDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            }
        )
        return response;
    }
    async getDocumentsList(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDocumentsList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        fechainicio: data.dateInit,
                        fechafinal: data.dateFinal,
                        user_Email: data.user_Email,
                        table: {
                            name: data.table,
                            doctype: data.docSubTypeDraft
                        },
                        employeeValue: data.employeeValue,
                        groupCodeValue: data.groupCodeValue,
                        switch1: data.switch1,
                        authorizedFilter: data.authorizedFilter,
                        docNumSearch: data.docNumSearch ? data.docNumSearch : '--',
                        searchSerieName: data.searchSerieName ? data.searchSerieName : '--',
                        searchByWhs: data.searchByWhs ? data.searchByWhs : '--',
                        docFilter: data?.docFilter ?? '--',
                        isCanceled: data?.isCanceled || 'N',
                    }
                ),
            },
        );
        return response;
    }

    async getDocumentsList_PROD(data) {
        const url = this.getEndpointUrl(SERVICE_API.getListDocumentsProd);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        fechainicio: data.dateInit,
                        fechafinal: data.dateFinal,
                        user_Email: data.user_Email,
                        table: {
                            name: data.table,
                            doctype: data.docSubTypeDraft
                        },
                        employeeValue: data.employeeValue,
                        groupCodeValue: data.groupCodeValue,
                        switch1: data.switch1,
                        authorizedFilter: data.authorizedFilter,
                        docNumSearch: data.docNumSearch ? data.docNumSearch : '--',
                        searchSerieName: data.searchSerieName ? data.searchSerieName : '--',
                        searchByWhs: data.searchByWhs ? data.searchByWhs : '--',
                        docFilter: data?.docFilter ?? '--'
                    }
                ),
            },
        );
        return response;
    }

    async getProdDocumentDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.getProdDocumentDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );

        return response;
    }


    async getDocumentsDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDocumentsDetails + "/" + data.doc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    { name: data.table, view: data.view, view2: data.view2 }
                ),
            },
        );

        return response;
    }

    async DownloadDocuments(data) {
        let url = this.getEndpointUrl(SERVICE_API.downloadDocuments);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async DownloadForeignDocs(data) {
        let url = this.getEndpointUrl(SERVICE_API.downloadForeignDocs);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async DownloadCancelationDocuments(data) {
        let url = this.getEndpointUrl(SERVICE_API.downloadCancelationDocuments);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getAllDocumentsToPrint(docEntryArray, table, view) {
        const url = this.getEndpointUrl(SERVICE_API.getAllDocumentsToPrint,
        );
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        docEntryArray,
                        table,
                        view
                    }
                ),
            },
        );
        return response;
    }
    async timbrar(data) {
        let url = this.getEndpointUrl(SERVICE_API.timbrar);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async CancelCFDI(data) {
        let url = this.getEndpointUrl(SERVICE_API.cancelCFDI);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ConsultarEstatusCFDI(data) {
        let url = this.getEndpointUrl(SERVICE_API.consultarEstatusCFDI);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async cancelRelatedCFDI(data) {
        let url = this.getEndpointUrl(SERVICE_API.cancelRelatedCFDI);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async CancelPayment(data) {
        let url = this.getEndpointUrl(SERVICE_API.CancelPayment);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async CancelPayments(data) {
        let url = this.getEndpointUrl(SERVICE_API.CancelPayments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async authorized(data) {
        let url = this.getEndpointUrl(SERVICE_API.createAuthorized);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async submitPartialEditRequest(data) {
        let url = this.getEndpointUrl(SERVICE_API.submitPartialEditRequest);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    };

    async approvePartialRequest(data) {
        let url = this.getEndpointUrl(SERVICE_API.approvePartialRequest);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    };

    async createDocumentAuthorized(data) {
        let url = this.getEndpointUrl(SERVICE_API.createDocumentAuthorized);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async authorizedDocument(data) {
        let url = this.getEndpointUrl(SERVICE_API.authorizedDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async cancelDocument(data) {
        let url = this.getEndpointUrl(SERVICE_API.cancelDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async cancelDocuments(data) {
        let url = this.getEndpointUrl(SERVICE_API.cancelDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async closeDocuments(data) {
        let url = this.getEndpointUrl(SERVICE_API.closeDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async closeDocument(data) {
        let url = this.getEndpointUrl(SERVICE_API.closeDoc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createNewDocument(data) {
        data.CurrDate = clientDate//DISABLE AUTHORIZATIONS
        let url = this.getEndpointUrl(SERVICE_API.createNewDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getCorrelativo(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCorrelativo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );

        return response;
    }

    async createNewStockTransfer(data) {
        let url = this.getEndpointUrl(SERVICE_API.createNewStockTransfer);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async validateDocsToBill(data) {
        let url = this.getEndpointUrl(SERVICE_API.validateDocsToBill);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async copyDocsToBill(data) {
        let url = this.getEndpointUrl(SERVICE_API.copyDocsToBill);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#region ##### INVENTORY COUNTING ############################################ ✔
    async inventoryDocumentsList(data) {
        let url = this.getEndpointUrl(SERVICE_API.getInventoryDocumentsList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async inventoryDocumentDetails(data) {
        let url = this.getEndpointUrl(SERVICE_API.getInventoryDocumentDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createInventoryDocument(data) {
        let url = this.getEndpointUrl(SERVICE_API.createNewInventoryDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async closeInventoryDocument(data) {
        let url = this.getEndpointUrl(SERVICE_API.closeInventoryDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion

    async autorizationModels(data) {
        data.CurrDate = clientDate//DISABLE AUTHORIZATIONS
        let url = this.getEndpointUrl(SERVICE_API.autorizationModels);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async autorizationInvoiceModels(data) {
        let url = this.getEndpointUrl(SERVICE_API.autorizationInvoiceModels);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }



    async createNewDocumentOfraft(data) {
        let url = this.getEndpointUrl(SERVICE_API.createNewDocumentOdraft);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async updateDocument(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateDocumentOfraft(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateDocumentOfraft);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async getSeries(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSeries);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async openAccountListBpAct() {
        const url = this.getEndpointUrl(SERVICE_API.openAccountListBpAct);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async openAccountListPaymentAct(data) {
        const url = this.getEndpointUrl(SERVICE_API.openAccountListPaymentAct);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async downloadTXT() {
        const url = this.getEndpointUrl(SERVICE_API.downloadTXT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCuentaMayor(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCuentaMayor);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getConsecutiveDocsInfoByBO(codeBO) {
        const url = this.getEndpointUrl(`${SERVICE_API.getConsecutiveDocsInfoByBO}/${codeBO}`);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },

            },
        );
        return response;
    }

    async upgradeDocumentLoop(data) {
        const url = this.getEndpointUrl(`${SERVICE_API.upgradeDocumentLoop}`);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),

            },
        );
        return response;
    }

    // ##### Branch Cashcut #####
    async branchCashCutAction(data) {
        const url = this.getEndpointUrl(SERVICE_API.branchCashCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    // ##### Apps Cashcut #####
    async validateVoucher(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateVoucher);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async cashCutVoucher(data) {
        const url = this.getEndpointUrl(SERVICE_API.cashCutVoucher);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async checkCashCutPayments(data) {
        const url = this.getEndpointUrl(SERVICE_API.checkCashCutPayments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getCashCutSapAmounts(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCashCutSapAmounts);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateCashCutInventory(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateCashCutInventory);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async insertIncompleteOperations(data) {
        const url = this.getEndpointUrl(SERVICE_API.insertIncompleteOperations);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getCuentaMayorPartner() {
        const url = this.getEndpointUrl(SERVICE_API.getCuentaMayorPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getBranches() {
        const url = this.getEndpointUrl(SERVICE_API.getBranches);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async listBranches() {
        const url = this.getEndpointUrl(SERVICE_API.listBranches);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getDepartment() {
        const url = this.getEndpointUrl(SERVICE_API.getDepartment);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async Middleware(id) {
        const url = this.getEndpointUrl(SERVICE_API.middleware + id);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async validateMiddleware() {
        const url = this.getEndpointUrl(SERVICE_API.validateMiddleware);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCountDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.countDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getDocumentsListInvoice(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDocumentsListInvoice);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        fechainicio: data.dateInit,
                        fechafinal: data.dateFinal,
                        DocSubType: data.docSubType,
                        user_Email: data.user_Email,
                        table: {
                            name: data.table,
                            doctype: data.docSubTypeDraft
                        },
                        switch1: data.switch1,
                        employeeValue: data.employeeValue,
                        groupCodeValue: data.groupCodeValue,
                        authorizedFilter: data.authorizedFilter,
                        docNumSearch: data.docNumSearch ? data.docNumSearch : '--',
                        searchSerieName: data.searchSerieName ? data.searchSerieName : '--'
                    }
                ),
            },
        );
        return response;
    }

    async getDocuments(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getPartnerListCreate(type, card, page, view = 'view') {
        const url = this.getEndpointUrl(SERVICE_API.getPartnerList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    type,
                    card,
                    page,
                    view
                })
            },
        );
        return response;
    }

    async getPartner(type, card, view = 'view') {
        const url = this.getEndpointUrl(SERVICE_API.getPartner + '/' + type + '/' + card + '/' + view);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getAddressParter(cardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getAddressPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ cardCode }),
            },
        );
        return response;
    }

    async getPartnerList(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getPartnerListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getItemsrList(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getItemListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getSpecialsPrice(body) {
        const url = this.getEndpointUrl(SERVICE_API.getSpecialPrice);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            },
        );
        return response;
    }

    async getPartnerDetails(cardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getPartnerShowView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ cardCode }),
            },
        );
        return response;
    }

    //#region ######### PRODUCTION #########
    async createNewDocProd(data) {
        let url = this.getEndpointUrl(SERVICE_API.createNewDocProd);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async updateNewDocProd(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateNewDocProd);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async getListProjects() {
        const url = this.getEndpointUrl(SERVICE_API.getListProjects);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }
    //#endregion ############################

    async getContactsList(CardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getContactsList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CardCode
                })
            },
        );
        return response;
    }

    async getWarehouseList(data = null) {
        const url = this.getEndpointUrl(SERVICE_API.getWarehouseList);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data
                })
            },
        );
        return response;
    }

    async getWarehouse(data = null) {
        const url = this.getEndpointUrl(SERVICE_API.getWarehouse);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data
                })
            },
        );
        return response;
    }

    async checkWhscodes(data = null) {
        const url = this.getEndpointUrl(SERVICE_API.checkWhscodes);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    data
                )
            },
        );
        return response;
    }

    async getAuditoryStock(data = null) {
        const url = this.getEndpointUrl(SERVICE_API.getAuditoryStock);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data
                })
            },
        );
        return response;
    }

    async getAuditoryWhs(data = null) {
        const url = this.getEndpointUrl(SERVICE_API.getAuditoryWhs);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data
                })
            },
        );
        return response;
    }

    async getItem(CardCode, view = null, searchItem, newOrderModel, DraftObjType = '') {

        const url = this.getEndpointUrl(SERVICE_API.getItem);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CardCode,
                    searchItem,
                    view,
                    newOrderModel,
                    DraftObjType,
                })
            },
        );
        return response;
    }

    async deleteLineITransporte(data) {

        const url = this.getEndpointUrl(SERVICE_API.deleteLineITransporte);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getItemsList(CardCode = null, view = null, searchItem = null, page = null, itemsPage = null, searchInvItems = null) {

        const url = this.getEndpointUrl(SERVICE_API.getItemsList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CardCode,
                    view,
                    searchItem,
                    page,
                    itemsPage,
                    searchInvItems
                })
            },
        );
        return response;
    }

    async getPriceKilo(ItemCode = null, WhsCode = null) {

        const url = this.getEndpointUrl(SERVICE_API.getPriceKilo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ItemCode,
                    WhsCode,
                })
            },
        );
        return response;
    }

    async getItemsPurchaseOrder(CardCode, Items) {

        const url = this.getEndpointUrl(SERVICE_API.getItemsPurchaseOrder);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CardCode,
                    Items,
                })
            },
        );
        return response;
    }

    async getItemPrice(data) {
        const url = this.getEndpointUrl(SERVICE_API.getItemPrice);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        data
                    })
            },
        );
        return response;
    }

    async getItemTaxCodePerceptions(data) {
        const url = this.getEndpointUrl(SERVICE_API.itemTaxCodePerceptions);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getItemsPrice(CardCode = null, Items = null, DocDate = null) {
        const url = this.getEndpointUrl(SERVICE_API.getItemsPrice);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        CardCode,
                        Items,
                        DocDate,
                    })
            },
        );
        return response;
    }

    async getPriceList() {
        const url = this.getEndpointUrl(SERVICE_API.getPriceList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getPriceListByItems(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPriceListByItems);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getBanks() {
        const url = this.getEndpointUrl(SERVICE_API.getBanks);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getBanksOptions() {
        const url = this.getEndpointUrl(SERVICE_API.getBanksOptions);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getToleranceInfo() {
        const url = this.getEndpointUrl(SERVICE_API.getToleranceInfo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getGroupCode() {
        const url = this.getEndpointUrl(SERVICE_API.getGroupCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getState() {
        const url = this.getEndpointUrl(SERVICE_API.getState);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCountry() {
        const url = this.getEndpointUrl(SERVICE_API.getCountry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getDistritos(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDistritos);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getProvincias(data) {
        const url = this.getEndpointUrl(SERVICE_API.getProvincias);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getUbigeo(data) {
        const url = this.getEndpointUrl(SERVICE_API.getUbigeo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async payMethod() {
        const url = this.getEndpointUrl(SERVICE_API.payMethod);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getGroupNum() {
        const url = this.getEndpointUrl(SERVICE_API.getGroupNum);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCurrencies() {
        const url = this.getEndpointUrl(SERVICE_API.getCurrencies);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getRateChange(DocDate) {
        const url = this.getEndpointUrl(SERVICE_API.getRateChange + '/' + DocDate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCurrenciesPartner() {
        const url = this.getEndpointUrl(SERVICE_API.getCurrenciesPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getTaxesList(validFor = null) {
        const url = this.getEndpointUrl(SERVICE_API.getTaxesList + '/' + validFor);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }
    async getTaxeList(taxcode) {
        const url = this.getEndpointUrl(SERVICE_API.getTaxe + "/" + taxcode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getProjectsListByPartner(CardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getProjectsListByPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CardCode }),
            },
        );
        return response;
    }

    async getBillingCatalogs() {
        const url = this.getEndpointUrl(SERVICE_API.getBillingCatalogs);
        const response = await apiFetchWithSession(url, { method: 'GET' });
        return response;
    }

    async getCentroCosteList(centro) {
        const url = this.getEndpointUrl(SERVICE_API.getCentroCosteList + "/" + centro);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getUserFields(table) {
        const url = this.getEndpointUrl(SERVICE_API.getUserFields);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ table }),
            },
        );
        return response;
    }

    async saveConfigHeaderUserFields(configHeaderUserFields, email) {
        const url = this.getEndpointUrl(SERVICE_API.saveConfigHeaderUserFields);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        configHeaderUserFields,
                        email
                    }),
            },
        );
        return response;
    }

    async getTransactions(transactionId) {

        const url = this.getEndpointUrl(SERVICE_API.getTransactions);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },

                body: JSON.stringify(
                    {
                        transactionId
                    })
            },
        );
        return response;
    }

    async getPaymnetList(docEntry, objType) {

        const url = this.getEndpointUrl(SERVICE_API.paymnetList);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },

                body: JSON.stringify(
                    {
                        docEntry,
                        objType
                    })
            },
        );
        return response;
    }

    async getAsiento(DocEntry) {

        const url = this.getEndpointUrl(SERVICE_API.getAsiento);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },

                body: JSON.stringify(
                    {
                        DocEntry
                    })
            },
        );
        return response;
    }

    async getAsientoContable(DocEntry) {

        const url = this.getEndpointUrl(SERVICE_API.getAsientoContable);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        DocEntry
                    })
            },
        );
        return response;
    }

    async getUsersList(search) {
        const url = this.getEndpointUrl(SERVICE_API.getUsersList + `/${search ? `${search}` : '-1'}`);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getEmployeeList() {
        const url = this.getEndpointUrl(SERVICE_API.getEmployeeList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getTerritories() {
        const url = this.getEndpointUrl(SERVICE_API.getTerritories);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getOwnersList() {
        const url = this.getEndpointUrl(SERVICE_API.getOwnersList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getInvoicePaymentList(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInvoicePaymentList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getCuentaBancosList() {
        const url = this.getEndpointUrl(SERVICE_API.getCuentaBancos);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getDownPaymentsByPartner(data) {

        let url = this.getEndpointUrl(SERVICE_API.getDownPaymentsByPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getCodigoEstadosList() {
        const url = this.getEndpointUrl(SERVICE_API.getCodigoEstados);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getBanksAndStates() {
        const url = this.getEndpointUrl(SERVICE_API.getBanksAndStates);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getGroupsItemData(table) {
        const url = this.getEndpointUrl(SERVICE_API.getGroupsItemData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getProducersData() {
        const url = this.getEndpointUrl(SERVICE_API.getProducersData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getArticulos(table) {
        const url = this.getEndpointUrl(SERVICE_API.getArticulos);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async createBusinessPartner(data) {
        let url = this.getEndpointUrl(SERVICE_API.createBusinessPartnerView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateBusinessPartner(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateBusinessPartnerView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getGroupNumDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.getGroupNumDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async createGroupNum(data) {
        const url = this.getEndpointUrl(SERVICE_API.createGroupNum);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async updateGroupNum(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateGroupNum);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async paymentConds(data) {
        const url = this.getEndpointUrl(SERVICE_API.paymentConds);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async partnerGrpCreate(data) {
        let url = this.getEndpointUrl(SERVICE_API.partnerGrpCreate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async partnerGrpUpdate(data) {
        let url = this.getEndpointUrl(SERVICE_API.partnerGrpUpdate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createInventoryData(data) {
        let url = this.getEndpointUrl(SERVICE_API.createInventoryDataView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateInventoryData(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateInventoryDataView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getDataCsv(data) {

        const url = this.getEndpointUrl(SERVICE_API.getDataCsv);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        data: data
                    })

            },
        );
        return response;
    }

    async getDataCsvORDR(data) {

        const url = this.getEndpointUrl(SERVICE_API.getDataCsvORDR);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        data: data
                    })

            },
        );
        return response;
    }

    async loginPARTNER(credentials) {
        const url = this.getEndpointUrl(SERVICE_API.loginPARTNER);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            },
            'token'
        );
        return response;
    }

    async loginCLIENT(credentials) {
        const url = this.getEndpointUrl(SERVICE_API.loginCLIENT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            },
            'token'
        );
        return response;
    }

    async createAccountCLIENT(credentials) {
        const url = this.getEndpointUrl(SERVICE_API.createAccountCLIENT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            },
            'token'
        );
        return response;
    }

    async getShoppingCart() {
        const url = this.getEndpointUrl(SERVICE_API.getShoppingCart);

        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getShoppingCartCLIENT() {
        const url = this.getEndpointUrl(SERVICE_API.getShoppingCartCLIENT);

        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async setShoppingCart(shoppingCart) {
        const url = this.getEndpointUrl(SERVICE_API.setShoppingCart);

        let itemsArray = {
            items: shoppingCart.itemsArray,
            shoppingCartId: shoppingCart.id,
        };

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ itemsArray }),
        });
        return response;
    }

    async setShoppingCartPublic(shoppingCart, token = null) {
        const url = this.getEndpointUrl(SERVICE_API.setShoppingCartCLIENT);

        let itemsArray = {
            items: shoppingCart.itemsArray,
            shoppingCartId: shoppingCart.id,
        };

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ itemsArray }),
            },
            token
        );
        return response;
    }

    async getFavorites() {
        const url = this.getEndpointUrl(SERVICE_API.getFavoritesItems);

        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async setFavorites(shoppingCart) {
        const url = this.getEndpointUrl(SERVICE_API.setFavoritesItems);

        let itemsArray = {
            items: shoppingCart.itemsFavorites,
        };

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ itemsArray }),
        });
        return response;
    }

    async getFavoritesPublic() {
        const url = this.getEndpointUrl(SERVICE_API.getFavoritesItemsPublic);

        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async setFavoritesPublic(shoppingCart) {
        const url = this.getEndpointUrl(SERVICE_API.setFavoritesItemsPublic);

        let itemsArray = {
            items: shoppingCart.itemsFavorites,
        };

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ itemsArray }),
        });
        return response;
    }

    async getItems(search = null) {
        let params = '';

        if (search) {
            params = '?search=' + search;
        }

        const url = this.getEndpointUrl(SERVICE_API.getItems + params);

        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getItemsPublic(search = null) {
        let params = '';

        if (search) {
            params = '?search=' + search;
        }

        const url = this.getEndpointUrl(SERVICE_API.getItemsPublic + params);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
            'token'
        );
        return response;
    }

    async getitemsDetails(ItemCode) {
        const url = this.getEndpointUrl(SERVICE_API.getitemsDetails + ItemCode);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getitemsDetailsPublic(ItemCode) {
        const url = this.getEndpointUrl(SERVICE_API.getitemsDetailsPublic + ItemCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
            'token'
        );
        return response;
    }

    async sendShoppingCartToBO(id) {
        const url = this.getEndpointUrl(SERVICE_API.sendShoppingCartToBO);

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: { shoppingCartId: id } }),
        });
        return response;
    }

    async sendShoppingCartToSave(id) {
        const url = this.getEndpointUrl(SERVICE_API.sendShoppingCartToSave);

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ itemsArray: { shoppingCartId: id } }),
        });
        return response;
    }

    async sendShoppingCartToPreliminar(id) {
        const url = this.getEndpointUrl(SERVICE_API.sendShoppingCartToPreliminar);

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: { shoppingCartId: id } }),
        });
        return response;
    }

    async sendShoppingCartToBOQuotation(id) {
        const url = this.getEndpointUrl(SERVICE_API.sendShoppingCartToBOQuotation);

        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: { shoppingCartId: id } }),
        });
        return response;
    }

    async getTags() {
        const url = this.getEndpointUrl(SERVICE_API.getTags);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
            'token'
        );
        return response;
    }

    async getCostumers() {
        const url = this.getEndpointUrl(SERVICE_API.getCostumers);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getOrders() {
        const url = this.getEndpointUrl(SERVICE_API.ordersList + '?fechainicio=&fechafinal=');
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getOrderDetails(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.orderDetails + docEntry);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getBillings() {
        const url = this.getEndpointUrl(SERVICE_API.billingsList + '?fechainicio=&fechafinal=');
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getBillingsDetails(DocNum) {
        const url = this.getEndpointUrl(SERVICE_API.billingDetails + DocNum);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }


    async getQuotation() {
        const url = this.getEndpointUrl(SERVICE_API.quotationList + '?fechainicio=&fechafinal=');
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getQuotationDetails(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.quotationDetails + docEntry);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }
    ///////////////////////////////////////////QUERY MANAGER///////////////////////////////////////////
    async getColumnsNames(data) {
        const url = this.getEndpointUrl(SERVICE_API.getColumnsNames);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSearchFormater() {
        const url = this.getEndpointUrl(SERVICE_API.getSearchFormater);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            },
        );
        return response;
    }

    async getSearchFormaterSubCategories(param) {
        const url = this.getEndpointUrl(SERVICE_API.getSearchFormaterSubCategories);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ QCategory: param })
            },
        );
        return response;
    }

    async getSelectsQueryManager(fields) {
        const url = this.getEndpointUrl(SERVICE_API.getSelectsQueryManager);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ fields })
            },
        );
        return response;
    }
    async getUserFieldsSelectsQueryManager(name, table) {
        const url = this.getEndpointUrl(SERVICE_API.getUserFieldsSelectsQueryManager);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ QFields: name, QTable: table })
            },
        );
        return response;
    }

    async createQuery(data) {
        const url = this.getEndpointUrl(SERVICE_API.createQuery);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async getAccountBalance(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAccoutBalance);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getProjectsList(data) {
        const url = this.getEndpointUrl(SERVICE_API.getProjectsList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getPaymentMethods() {
        const url = this.getEndpointUrl(SERVICE_API.getPaymentMethods);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }


    async getTemps() {
        const url = this.getEndpointUrl(SERVICE_API.tempsList);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getGoats() {
        const url = this.getEndpointUrl(
            SERVICE_API.goatsList + '?fechainicio=20190901&fechafinal=20190911&tipodoc=13'
        );
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getPreliminaries() {
        const url = this.getEndpointUrl(SERVICE_API.preliminariesList + '?fechainicio=&fechafinal=');
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getPreliminariesDetails(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.preliminarDetails + docEntry);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async setCommentsAutorizations(comments, docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.setComments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ comments, docEntry })
            },
        );
        return response;
    }

    async getBestSellers() {
        const url = this.getEndpointUrl(SERVICE_API.bestSellers);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getInfoAccount() {
        const url = this.getEndpointUrl(SERVICE_API.getInfoAccount);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async SearchItems(data) {
        const url = this.getEndpointUrl(SERVICE_API.SearchItems);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async SearchPriceItems(data) {
        const url = this.getEndpointUrl(SERVICE_API.SearchPriceItems);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async SearchPartner(partnerSearch = '') {
        const url = this.getEndpointUrl(SERVICE_API.SearchPartners + '/' + partnerSearch);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getAdminUsersList(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getAdminUsersListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getAdminUsersDetails(UserID) {
        const url = this.getEndpointUrl(SERVICE_API.getAdminUsersView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ UserID }),
            },
        );
        return response;
    }

    async getWalletUserPermissions(CardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getUserWalletPermission + '/' + CardCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getTwoStepsKey(UserID) {
        const url = this.getEndpointUrl(SERVICE_API.getTwoStepsKey);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ UserID }),
            },
        );
        return response;
    }
    async showPassword(UserID) {
        const url = this.getEndpointUrl(SERVICE_API.showPassword);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ UserID }),
            },
        );
        return response;
    }

    async createNewDocumentPS(data) {
        // Adjuntamos un id unico de solicitud para enviar al back
        let requestID = sessionStorage.getItem(config.localStorageNamed + 'Request-ID-PSD');
        if (!requestID) {
            requestID = uuidv4();
            sessionStorage.setItem(config.localStorageNamed + 'Request-ID-PSD', requestID);
        }

        let url = this.getEndpointUrl(SERVICE_API.createNewDocumentPS);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Request-ID': requestID,
                },
                body: JSON.stringify(data),
            },
        );
        if (response.status === 1 || (typeof response.from !== 'undefined' && response.from === 0) || response?.data?.DocEntry) {
            sessionStorage.removeItem(config.localStorageNamed + 'Request-ID-PSD');
        }
        return response;
    }

    async createCreditAndDebitNotes(data) {
        let url = this.getEndpointUrl(SERVICE_API.createCreditAndDebitNotesPS);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ValidateClientVersion(data) {
        let url = this.getEndpointUrl(SERVICE_API.validateClientVersion);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createNewBusinessPartnerPS(data) {
        let url = this.getEndpointUrl(SERVICE_API.createNewBusinessPS);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateBusinessPartnerPS(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateBusinessPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async validateSerialNumbers(data) {
        let url = this.getEndpointUrl(SERVICE_API.validateSerialNumbers);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateAdminUsers(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateAdminUsersView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createAdminUsers(data) {
        let url = this.getEndpointUrl(SERVICE_API.createAdminUsersView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async updatePassAdminUsers(data) {
        let url = this.getEndpointUrl(SERVICE_API.updatePassAdminUsersView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async saveMITData(data) {
        let url = this.getEndpointUrl(SERVICE_API.saveMITData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteAdminUsers(data) {
        let url = this.getEndpointUrl(SERVICE_API.deleteAdminUsersView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSucursales(data = false) {
        const aux = data !== undefined ? { data } : { data: false }
        const url = this.getEndpointUrl(SERVICE_API.sucursales);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(aux),
            },
        );
        return response;
    }

    async getlistJefesArea(data = false) {
        const aux = data !== undefined ? { data } : { data: false }
        const url = this.getEndpointUrl(SERVICE_API.jefesArea);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(aux),
            },
        );
        return response;
    }


    async getDataEmployee() {
        const url = this.getEndpointUrl(SERVICE_API.dataEmployee);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getPrioridadVenta() {
        const url = this.getEndpointUrl(SERVICE_API.prioridadVenta);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            },
        );
        return response;
    }

    async getEmployee() {
        const url = this.getEndpointUrl(SERVICE_API.getEmployeeListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async createEmployee(data) {
        let url = this.getEndpointUrl(SERVICE_API.createEmployeeView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getEmployeeDetails(empId) {
        const url = this.getEndpointUrl(SERVICE_API.getEmployeeView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ empId }),
            },
        );
        return response;
    }

    async updateEmployee(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateEmployeeView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updatePassEmployee(data) {
        let url = this.getEndpointUrl(SERVICE_API.updatePassEmployeeView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteEmployee(data) {
        let url = this.getEndpointUrl(SERVICE_API.deleteEmployeeView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getOneSucursal(id) {
        const url = this.getEndpointUrl(SERVICE_API.oneSucursal + '/' + id);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getInvoices(datos) {
        const url = this.getEndpointUrl(SERVICE_API.getInvoices);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(datos),
            },
        );
        return response;
    }

    async getIncomingPayments(datos) {
        const url = this.getEndpointUrl(SERVICE_API.getIncomingPayments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(datos),
            },
        );
        return response;
    }

    async CancelIncomingPayments(datos) {
        const url = this.getEndpointUrl(SERVICE_API.CancelIncomingPayments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(datos),
            },
        );
        return response;
    }

    async insertWorkShiftT() {
        const url = this.getEndpointUrl(SERVICE_API.insertWorkShiftT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getPendingPaymentsBySession(data) {
        const url = this.getEndpointUrl(
            SERVICE_API.getPendingPaymentsBySession
        );

        return await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    }

    async approvePendingPaymentsRestriction(data) {
        const url = this.getEndpointUrl(
            SERVICE_API.approvePendingPaymentsRestriction
        );

        return await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    }

    async createSucursal(data) {
        let url = this.getEndpointUrl(SERVICE_API.createSucursal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async createPayMethod(data) {
        let url = this.getEndpointUrl(SERVICE_API.createPayMethod);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getWhsCodes(data) {
        const url = this.getEndpointUrl(SERVICE_API.getWhsCodes);
        const response = await apiFetchWithSession(
            url,
            // {
            //     method: 'GET',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            // },
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async checkWorkSession() {
        const url = this.getEndpointUrl(SERVICE_API.checkWorkSession);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }
    async sellTypeSession(data) {
        let url = this.getEndpointUrl(SERVICE_API.sellTypeSession);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),

            },
        );
        return response;
    }

    async updateSucural(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateSucursal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),

            },
        );
        return response;
    }

    async closeWorkShiftT(data) {
        const url = this.getEndpointUrl(SERVICE_API.closeWorkShiftT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),

            },
        );
        return response;
    }

    async partialCut(idSession) {
        const url = this.getEndpointUrl(SERVICE_API.partialCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ idSession }),
            },
        );
        return response;
    }

    async BlindCut(idSession) {
        const url = this.getEndpointUrl(SERVICE_API.blindCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ idSession }),
            },
        );
        return response;
    }

    async DetailCutUser(data) {
        const url = this.getEndpointUrl(SERVICE_API.detailCutUser);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async searchLastCashCuts(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchLastCashCuts);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    // `signal` permite que un filtro nuevo cancele esta consulta HANA potencialmente costosa.
    async getPendingCutsByBranch(data, signal) {
        const url = this.getEndpointUrl(SERVICE_API.pendingCutsByBranch);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
                // Envía AbortController.signal a fetch; apiFetchWithSession gestiona la autenticación.
                signal,
            },
        );
        return response;
    }

    // Obtiene solo las facturas que activaron la condición de corte pendiente de una sesión.
    async getPendingCutProblemDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.pendingCutProblemDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async processPayments(data) {
        const url = this.getEndpointUrl(SERVICE_API.processPayments);
        return apiFetchWithSession(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
    }

    async reprocessPendingCuts(data) {
        const url = this.getEndpointUrl(SERVICE_API.reprocessPendingCuts);
        return apiFetchWithSession(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
    }

    async reprocessPendingInvoices(data) {
        const url = this.getEndpointUrl(SERVICE_API.reprocessPendingInvoices);
        return apiFetchWithSession(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
    }

    async SearchLastBOEmployeesCashCuts(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchLastBOEmployeesCashCuts);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ApproveCashCut(data) {
        const url = this.getEndpointUrl(SERVICE_API.ApproveCashCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ApproveCashCutInventory(data, cashCut) {
        const url = this.getEndpointUrl(SERVICE_API.ApproveCashCutInventory);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data, cashCut),
            },
        );
        return response;
    }

    async ReqInventoryApproval(data) {
        const url = this.getEndpointUrl(SERVICE_API.ReqInventoryApproval);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async InventoryTwoSteps(data) {
        const url = this.getEndpointUrl(SERVICE_API.InventoryTwoSteps);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async DetailCutInventory(data) {
        const url = this.getEndpointUrl(SERVICE_API.DetailCutInventory);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetEditCutInventory(data) {
        const url = this.getEndpointUrl(SERVICE_API.GetEditCutInventory);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getAmountEfectivo(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAmountEfectivo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async CreateInventoryCountings(data) {
        const url = this.getEndpointUrl(SERVICE_API.CreateInventoryCountings);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async BranchOfficeEmployeesCut(data) {
        const url = this.getEndpointUrl(SERVICE_API.branchOfficeEmployeesCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#region Partner Documents
    async GetPartnerDocumentsList(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPartnerDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion

    async BranchOfficeGeneralCut(data) {
        const url = this.getEndpointUrl(SERVICE_API.branchOfficeGeneralCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async SearchBranchOfficeInvoices(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchBranchOfficeInvoices);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async SearchBranchOfficeCreditNotes(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchBranchOfficeCreditNotes);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSPReportData(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSPReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async getInventoryData(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInventoryData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getMovementsCash(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCashMovements);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async showWorkShiftHistory(data) {
        const url = this.getEndpointUrl(SERVICE_API.showWorkShiftHistory);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getHistoryDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.getHistoryDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSaleDocuments(data) {
        let url = this.getEndpointUrl(SERVICE_API.getSaleDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getReturnFolioAmount(data) {
        let url = this.getEndpointUrl(SERVICE_API.getReturnFolioAmount);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetCommentsAuthorization(data) {
        let url = this.getEndpointUrl(SERVICE_API.getCommentsAuthorization);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createMovementCash(data) {
        let url = this.getEndpointUrl(SERVICE_API.createCashMovements);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getPrintReports(data) {
        const url = this.getEndpointUrl(SERVICE_API.printReports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async setRegisterReprint(data) {
        const url = this.getEndpointUrl(SERVICE_API.registerReprint);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async printSunatDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.printSunatDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getPrintDocsInfo(data) {
        const url = this.getEndpointUrl(SERVICE_API.sendprintDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async SendPrintDocsByEmail(data) {

        const url = this.getEndpointUrl(SERVICE_API.sendPrintDocsByEmail);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async sendEmailWithPDF(data) {
        const url = this.getEndpointUrl(SERVICE_API.sendEmailWithPDF);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async searchOrders(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchOrders);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createInvoiceCounter(data) {
        const url = this.getEndpointUrl(SERVICE_API.createInvoiceCounter);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async SaveChangesOrderInvoice(data) {
        const url = this.getEndpointUrl(SERVICE_API.saveChangesOrderInvoice);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ReturnDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.returnDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getDestinationAccounts() {
        const url = this.getEndpointUrl(SERVICE_API.getDestinationAccounts);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async generateJournalEntry(data) {
        const url = this.getEndpointUrl(SERVICE_API.generateJournalEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSavedSales(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSavedSales);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getDataFromDraft(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDataFromDraft);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getDataFromFirmeDoc(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDataFromFirmeDoc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteDraft(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteDraft);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSettings() {
        const url = this.getEndpointUrl(SERVICE_API.getSettings);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async UpdateSettings(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateSettings);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ValidateBPToDH(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateBPToDH);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async SendAddressCounter(data) {
        const url = this.getEndpointUrl(SERVICE_API.sendAddressCounter);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getJournalEntry(fechainicio, fechafinal, nroDoc) {
        const url = this.getEndpointUrl(SERVICE_API.getJournalEntry + '/' + fechainicio + '/' + fechafinal + '/' + nroDoc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async SearchStockByItem(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchStockByItem);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getOneJournalEntry(id) {
        const url = this.getEndpointUrl(SERVICE_API.oneJournalEntry + '/' + id);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCards() {
        const url = this.getEndpointUrl(SERVICE_API.getCards);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCard(cardId) {
        const url = this.getEndpointUrl(SERVICE_API.getCard + "/" + cardId);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    //#region ######### BATCH ###############################################

    async getBatchItems(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBatchs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetBatchsToReturn(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBatchsToReturn);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getBatchReport(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBatchsReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async getBatchReportLine(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBatchReportLine);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async cancelDocumentCounter(data) {
        const url = this.getEndpointUrl(SERVICE_API.cancelDocumentCounter);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async PrintDocuments(data) {
        try {
            return await fetch('http://localhost:8000',
                {
                    method: 'POST',
                    keepalive: true,
                    mode: 'no-cors',
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });

        } catch (e) {
            return {
                status: 0,
                message: 'Ocurrió un error inesperado, por favor intente más tarde',
            };
        }
    }

    //#endregion

    async getMyStockTransfers(typeTransfer) {
        const url = this.getEndpointUrl(SERVICE_API.getEntryTransfers + "/" + typeTransfer);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }


    async GenerateReports(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateReports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GenerateReportsByStock(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateReportsByStock);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GenerateReportsCollect(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateReportsCollect);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GenerateReportsKardex(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateReportsKardex);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getSellersReports(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSellersReports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getReserveInvoicesReport(data) {
        const url = this.getEndpointUrl(SERVICE_API.getReserveInvoicesReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GenerateReportsOperationsVendor(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateReportsOperationsVendor);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GenerateCierreCajaReport(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateCierreCajaReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GenerateContrasteCobranzaReport(data) {
        const url = this.getEndpointUrl(SERVICE_API.GenerateContrasteCobranzaReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getSoldItemsByDate(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSoldItemsByDate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getPurchasingDocsReports(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPurchasingDocsReports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GlobalInvoiceDelivery(data) {
        const url = this.getEndpointUrl(SERVICE_API.GlobalInvoiceDelivery);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getUsoCFDI() {
        const url = this.getEndpointUrl(SERVICE_API.getUsoCFDI);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getRegimenFiscal() {
        const url = this.getEndpointUrl(SERVICE_API.getRegimenFiscal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getAcctCodeType_I_O(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAcctCodeType_I_O);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSellersByBO(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSellersByBO);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    
    async generateEstatusFacturasReport(data) {
        const url = this.getEndpointUrl(SERVICE_API.generateEstatusFacturasReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async PrintEmployeesBOCut() {
        const url = this.getEndpointUrl(SERVICE_API.printEmployeesBOCut);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }
    async PrintEmployeesBOCutAll() {
        const url = this.getEndpointUrl(SERVICE_API.printEmployeesBOCutAll);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async SearchReserveInvoiceDoc(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchReserveInvoiceDoc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }


    //#region CARTA PORTE

    // FIGURA TRANSPORTE
    async getFiguraTransporteList(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getFiguraTransporteListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getFiguraTransporteDetails(codigo) {
        const url = this.getEndpointUrl(SERVICE_API.getFiguraTransporteShowView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ codigo }),
            },
        );
        return response;
    }

    async updateFiguraTransporteManager(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateFiguraTransporteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createFiguraTransporteManager(data) {
        let url = this.getEndpointUrl(SERVICE_API.createFiguraTransporteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteFiguraTransporteManager(codigo) {
        let url = this.getEndpointUrl(SERVICE_API.deleteFiguraTransporteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ codigo }),
            },
        );
        return response;
    }

    async getFiguraTransporteInfoCatalogs(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getFiguraTransporteCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    // TRANSPORTES
    async getTransporteList(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getTransporteListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getTransporteDetails(codigo, tipoTransporte) {
        const url = this.getEndpointUrl(SERVICE_API.getTransporteShowView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ codigo, tipoTransporte }),
            },
        );
        return response;
    }

    async updateTransporteManager(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateTransporteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createTransporteManager(data) {
        let url = this.getEndpointUrl(SERVICE_API.createTransporteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteTransporteManager(codigo, tipoTransporte) {
        let url = this.getEndpointUrl(SERVICE_API.deleteTransporteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ codigo, tipoTransporte }),
            },
        );
        return response;
    }

    async getTransporteInfoCatalogs(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getTransporteCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    // CARTA PORTE
    async getCartaPorteList(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getCartaPorteListView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getCartaPorteDetails(codigo) {
        const url = this.getEndpointUrl(SERVICE_API.getCartaPorteShowView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ codigo }),
            },
        );
        return response;
    }

    async updateCartaPorteManager(data) {
        let url = this.getEndpointUrl(SERVICE_API.updateCartaPorteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createCartaPorteManager(data) {
        let url = this.getEndpointUrl(SERVICE_API.createCartaPorteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteCartaPorteManager(codigo) {
        let url = this.getEndpointUrl(SERVICE_API.deleteCartaPorteView);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ codigo }),
            },
        );
        return response;
    }

    async getCartaPorteInfoCatalogs(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getCartaPorteCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getClaveProd(data) {
        const url = this.getEndpointUrl(SERVICE_API.getClaveProd);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    // CATALOGOS DEL SAT DIRECCIONES
    async getCodigoPostalSAT(CodigoPostal) {
        let url = this.getEndpointUrl(SERVICE_API.getCodigoPostalSAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodigoPostal }),
            },
        );
        return response;
    }

    // CATALOGOS DEL SAT DIRECCIONES
    async getAddressDetailSAT(data) {
        let url = this.getEndpointUrl(SERVICE_API.getCodigoPostalSAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: {
                        action: (data?.action && data?.action !== '') ? data?.action : '--',
                        zipCode: (data?.zipCode && data?.zipCode !== '') ? data?.zipCode : '--',
                        state: (data?.state && data?.state !== '') ? data?.state : '--',
                        municipality: (data?.municipality && data?.municipality !== '') ? data?.municipality : '--',
                        district: (data?.district && data?.district !== '') ? data?.district : '--',
                    }
                }),
            },
        );
        return response;
    }

    // CATALOGS SAT DIRECCIONES
    async getCountrySAT() {
        const url = this.getEndpointUrl(SERVICE_API.getCountrySAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getStateSAT(c_Pais) {
        let url = this.getEndpointUrl(SERVICE_API.getStateSAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ c_Pais }),
            },
        );
        return response;
    }

    async getMunicipioSAT(c_Estado) {
        let url = this.getEndpointUrl(SERVICE_API.getMunicipioSAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ c_Estado }),
            },
        );
        return response;
    }

    async getLocalidadSAT(c_Estado) {
        let url = this.getEndpointUrl(SERVICE_API.getLocalidadSAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ c_Estado }),
            },
        );
        return response;
    }

    async getColoniaSAT(CodigoPostal) {
        let url = this.getEndpointUrl(SERVICE_API.getColoniaSAT);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodigoPostal }),
            },
        );
        return response;
    }

    async getInvoicesPorte(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInvoicesPorte);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    // Uso interno
    async getValidateUser() {
        const url = this.getEndpointUrl(SERVICE_API.getUsoInterno);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getBPUsoInterno(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBPUsoInterno);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    //#endregion

    //#region LEYENDAS FISCALES
    async createNewLeyendaFiscal(data) {
        const url = this.getEndpointUrl(SERVICE_API.createNewLeyendaFiscal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion

    //#region COMERCIO EXTERIOR
    async createNewComercioExterior(data) {
        const url = this.getEndpointUrl(SERVICE_API.createNewComercioExterior);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion

    async getPendingTimbraDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPendingTimbraDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getInfoPendingTimbraDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInfoPendingTimbraDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateTimbraDocModel(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateTimbraDocModel);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async DownloadFiles(data) {
        let url = this.getEndpointUrl(SERVICE_API.downloadFiles);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#region ######### REQUEST PAY WITH CARD TERMINAL ###############################################
    async PrintVouchersMIT(data) {
        try {
            return await fetch('http://localhost:9117',
                {
                    method: 'POST',
                    keepalive: true,
                    mode: 'no-cors',
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });

        } catch (e) {
            return {
                status: 0,
                message: 'Ocurrió un error inesperado, por favor intente más tarde',
            };
        }
    }

    async PayWithCreditTerminal(data) {
        try {
            return await fetch('http://localhost:8117/makePayment',
                {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });
        } catch (e) {
            return {
                status: 0,
                message: `Ocurrió un error inesperado, por favor intente más tarde. ${e}`,
            };
        }
    }

    async CheckConnection(data) {
        try {
            return await fetch('http://localhost:8117/checkconnection',
                {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });
        } catch (e) {
            return {
                status: 0,
                message: `Ocurrió un error inesperado, por favor intente más tarde. ${e}`,
            };
        }
    }

    async RequestPayment(data) {
        try {
            return await fetch('http://localhost:8117/requestpaymentinfo',
                {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });
        } catch (e) {
            return {
                status: 0,
                message: `Ocurrió un error inesperado, por favor intente más tarde. ${e}`,
            };
        }
    }

    async CancelTransaction(data) {
        try {
            return await fetch('http://localhost:8117/canceltransaction',
                {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });
        } catch (e) {
            return {
                status: 0,
                message: `Ocurrió un error inesperado, por favor intente más tarde. ${e}`,
            };
        }
    }

    async ReprintTransaction(data) {
        try {
            return await fetch('http://localhost:8117/reprinttransaction',
                {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });
        } catch (e) {
            return {
                status: 0,
                message: `Ocurrió un error inesperado, por favor intente más tarde. ${e}`,
            };
        }
    }

    async CheckPrinter(data) {
        try {
            return await fetch('http://localhost:8117/checkprinter',
                {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });
        } catch (e) {
            return {
                status: 0,
                message: `Ocurrió un error inesperado, por favor intente más tarde. ${e}`,
            };
        }
    }
    //#endregion


    //#region ######### SELLERS ROUTES ADMIN ##################################
    async getRoutes() {
        const url = this.getEndpointUrl(SERVICE_API.getRoutes);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getUnassignedPartners(search) {
        const url = this.getEndpointUrl(SERVICE_API.getUnasignedPartners + `/${search || ""}`);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getRoutesEvents() {
        const url = this.getEndpointUrl(SERVICE_API.getRoutesEvents);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async createNewRoute(routeDoc) {
        const url = this.getEndpointUrl(SERVICE_API.createNewRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ routeDoc })
            },

        );
        return response;
    }

    async getAddressCoordinates(cardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getAddressCoordinates);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ cardCode })
            },

        );
        return response;
    }

    async getRoutePoints(routeID) {
        const url = this.getEndpointUrl(SERVICE_API.getRoutePoints);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ routeID })
            },

        );
        return response;
    }

    async updateRoute(RouteDoc) {
        const url = this.getEndpointUrl(SERVICE_API.updateRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ RouteDoc })
            },

        );
        return response;
    }

    async updateSAPRoute(partner) {
        const url = this.getEndpointUrl(SERVICE_API.updateSAPRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ partner })
            },

        );
        return response;
    }

    async deleteRoute(RouteDoc) {
        const url = this.getEndpointUrl(SERVICE_API.deleteRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ RouteDoc })
            },

        );
        return response;
    }

    async createNewRouteEvent(EventModel) {
        const url = this.getEndpointUrl(SERVICE_API.createNewRouteEvent);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ EventModel })
            },

        );
        return response;
    }

    async getEventInfo(idEvent) {
        const url = this.getEndpointUrl(SERVICE_API.getEventInfo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ idEvent })
            },

        );
        return response;
    }

    async deleteEvent(IdEVRO) {
        const url = this.getEndpointUrl(SERVICE_API.deleteEvent);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ IdEVRO })
            },

        );
        return response;
    }

    async GetSellers() {
        const url = this.getEndpointUrl(SERVICE_API.getSellers);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    //#endregion


    //#region ######### DELIVERIES ROUTES ADMIN ###############################

    async getDeliveryMountEvent(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDeliveryMountEvent);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getAllUnAssignedDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAllUnAssignedDocs);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async getDrivers() {
        const url = this.getEndpointUrl(SERVICE_API.getDrivers);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getAdminDeliveriesData() {
        const url = this.getEndpointUrl(SERVICE_API.getAdminDeliveriesData);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getCreatedRouteDeliveries20(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCreatedRouteDeliveries20);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async createdRouteDeliveries20(data) {
        const url = this.getEndpointUrl(SERVICE_API.createdRouteDeliveries20);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async getRouteDeliveryDetails20(data) {
        const url = this.getEndpointUrl(SERVICE_API.getRouteDeliveryDetails20);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async updateRouteDeliveryDetails20(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateRouteDeliveryDetails20);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async GetAllRoutes() {
        const url = this.getEndpointUrl(SERVICE_API.getAllRoutes);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async GenerateRouteDocByIA(data) {
        const url = this.getEndpointUrl(SERVICE_API.generateRouteDocByIA);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async GetAvailableManualLines(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAvailableManualLines);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }

    async getVehicles() {
        const url = this.getEndpointUrl(SERVICE_API.getVehicles);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async getDeliveryRoutesByDate(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDeliveryRoutesByDate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getDeliveryEventInfo(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDeliveryEventInfo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async GetEstimatedRoute() {
        const url = this.getEndpointUrl(SERVICE_API.getEstimatedRoute);
        const response = await apiFetchWithSession(url, {
            method: 'GET',
        });
        return response;
    }

    async createDeliveryRoute(data) {
        const url = this.getEndpointUrl(SERVICE_API.createDeliveryRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async deleteDeliveryRouteEvent(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteDeliveryRouteEvent);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getDeliveryRoutePoints(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDeliveryRoutePoints);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async unlinkDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.unlinkDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async updateDeliveryRoute(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateDeliveryRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async deleteDeliveryRoute(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteDeliveryRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getDocsByTurn(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDocsByTurn);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getLinesToDelivery(data) {
        const url = this.getEndpointUrl(SERVICE_API.getLinesToDelivery);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async scheduleToRoute(data) {
        const url = this.getEndpointUrl(SERVICE_API.scheduleToRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }


    async getAvailableInfoToRoute(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAvailableInfoToRoute);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getPolygons(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPolygons);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getTodayDocsCoordniates(data) {
        const url = this.getEndpointUrl(SERVICE_API.getTodayDocsCoordniates);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getDriverDocuments(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDriverDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }
    async getPolygonByAddress(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPolygonByAddress);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }
    async getWhsByAddress(data) {
        const url = this.getEndpointUrl(SERVICE_API.getWhsByAddress);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    async getInitialData(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInitialData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },

        );
        return response;
    }

    //#endregion

    //#region ######### AUTHORIZE PARTNERS ###############################################

    async getAuthoBusinessPartners(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAuthoBusinessPartners);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async sendAuthorizations(data) {
        const url = this.getEndpointUrl(SERVICE_API.sendAuthorizations);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }



    //#endregion

    //#region ######### DRIVERS ###############################################
    async updateDriver(data) {
        let url = this.getEndpointUrl(SERVICE_API.adminUpdateDriver);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async showDriverDetails(data) {
        let url = this.getEndpointUrl(SERVICE_API.adminShowDriver);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async showAuthorizePartnerDetails(data) {
        let url = this.getEndpointUrl(SERVICE_API.showAuthorizePartnerDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getBPListProps() {
        let url = this.getEndpointUrl(SERVICE_API.getPartnersListProps);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            },
        );
        return response;
    }

    async createDriver(data) {
        let url = this.getEndpointUrl(SERVICE_API.adminCreateDriver);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async showVehicleDetails(data) {
        let url = this.getEndpointUrl(SERVICE_API.vehicleShow);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateVehicle(data) {
        let url = this.getEndpointUrl(SERVICE_API.vehicleUpdate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async createVehicles(data) {
        let url = this.getEndpointUrl(SERVICE_API.vehicleCreate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#endregion

    //#region ################## POINTS CARD ################ ✔
    async GetAllConfiguration(id) {
        const url = this.getEndpointUrl(SERVICE_API.GetAllConfiguration);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async GetDefinitions(id) {
        const url = this.getEndpointUrl(SERVICE_API.GetDefinitions);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getAllCustomersPoints(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAllCustomersPoints);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getOneCustomersPoints(id) {
        const url = this.getEndpointUrl(SERVICE_API.getOneCustomersPoints + "/" + id);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async createNewDefinition(data) {
        const url = this.getEndpointUrl(SERVICE_API.createNewDefinition);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async updatePointValue(data) {
        const url = this.getEndpointUrl(SERVICE_API.updatePointValue);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async updateInvoiceCredit(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateInvoiceCredit);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async updateLastDate(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateLastDate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async cardAccountStatus(cardCode) {
        const url = this.getEndpointUrl(SERVICE_API.cardAccountStatus + cardCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getPartnerPoints(type, card) {
        const url = this.getEndpointUrl(SERVICE_API.getPartnerPoints + '/' + type + '/' + card);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async NewCustomerPointsCard(data) {
        const url = this.getEndpointUrl(SERVICE_API.NewCustomerPointsCard);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async UpdateCustomerPointsCard(data) {
        const url = this.getEndpointUrl(SERVICE_API.UpdateCustomerPointsCard);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async resetDate() {
        const url = this.getEndpointUrl(SERVICE_API.resetDate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async validateGeneratePointsCard(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateGeneratePointsCard);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async returnPointsCard(data) {
        const url = this.getEndpointUrl(SERVICE_API.returnPointsCard);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion ################## POINTS CARD ################ ✔

    //#region ######### NOTIFICATIONS ###############################################
    async getNotifications(userID) {
        let url = this.getEndpointUrl(SERVICE_API.getNotifications + userID);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async viewedNotifications(data) {
        let url = this.getEndpointUrl(SERVICE_API.viewedNotifications);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async saveNotification(data) {
        let url = this.getEndpointUrl(SERVICE_API.createNotification);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async getDataNotifications(typeData, params = {}) {
        let url = this.getEndpointUrl(SERVICE_API.getDataNotifications + typeData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ params }),
            },
        );
        return response;
    }
    //#endregion

    //#region ######### SUGGESTION CATALOGS #########
    async getSuggestionCatalogs(data) {
        let url = this.getEndpointUrl(SERVICE_API.suggestionCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion ####################################

    //#region ######### NEW REPORTS #########
    async generateCreditWalletReport(data) {
        let url = this.getEndpointUrl(SERVICE_API.generateCreditWalletReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async generateAccountStatusReport(data) {
        let url = this.getEndpointUrl(SERVICE_API.generateAccountStatusReport);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async generateProductionReports(data) {
        let url = this.getEndpointUrl(SERVICE_API.generateProductionReports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion ############################

    //#region ######### XML #########
    async getDataXML(data) {
        let url = this.getEndpointUrl(SERVICE_API.getDataXML);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion ############################

    //#region ######### GET RECORDS ###############################################
    async getRecordsTable(table) {
        let url = this.getEndpointUrl(SERVICE_API.getRecordsTable + table);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    //#endregion ############################

    //#region ######### PRINT TAGS SECTION ###############################################
    async getDataToPrintTags(data) {
        let url = this.getEndpointUrl(SERVICE_API.getDataToPrintTags);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async PrintTags(data) {
        try {
            return await fetch('http://localhost:10117',
                {
                    method: 'POST',
                    keepalive: true,
                    mode: 'no-cors',
                    headers: {
                        accept: 'application/json',
                    },
                    body: JSON.stringify(data)
                })

                .then(async (response) => {
                    return await response.json()
                })
                .catch((error) => {
                    return {
                        status: 0,
                        message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    };
                });

        } catch (e) {
            return {
                status: 0,
                message: 'Ocurrió un error inesperado, por favor intente más tarde',
            };
        }
    }

    //#endregion

    //#region ######### PRODUCTION #########

    async getListItems(search, view = null, page = 0, type = 4) {

        const url = this.getEndpointUrl(SERVICE_API.getListItems);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    search,
                    view,
                    page,
                    type
                })
            },
        );
        return response;
    }

    async getKitDetails(TreeCode) {
        const url = this.getEndpointUrl(SERVICE_API.getKitDetails);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    TreeCode
                })
            },
        );
        return response;
    }


    async getListMaterial(search, view = null, page = 0) {

        const url = this.getEndpointUrl(SERVICE_API.getListMaterial);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    search,
                    view,
                    page,
                })
            },
        );
        return response;
    }


    async getOrderProdDetails(DocEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getOrderProdDetails);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    DocEntry
                })
            },
        );
        return response;
    }

    async getProperties(table) {
        const url = this.getEndpointUrl(SERVICE_API.getProperties + table);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async recordsForAssistant(data) {
        const url = this.getEndpointUrl(SERVICE_API.recordsForAssistant);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    //#endregion ############################
    async getItmGrpEWallet() {
        const url = this.getEndpointUrl(SERVICE_API.getItmGrpEWallet);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }
    static async getSessionToken() {
        return await FINISH_THE_RACE(localStorage.getItem(config.localStorageNamed + 'Token'), F1_GRILL.CHECO_PEREZ);
    }

    getEndpointUrl(urlPath) {
        let localIP = JSON.parse(localStorage.getItem(config.localStorageNamed + 'ConfigURL'));
        return (localIP ? LOCAL_IP : this.baseUrl) + urlPath;
    }

    //#region ######### MRP #########
    async MRPDocumentsList(data) {
        const url = this.getEndpointUrl(SERVICE_API.MRPDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async MRPDocumentDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.MRPDocumentDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async createMRPDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.createMRPDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async recordScenario(data) {
        const url = this.getEndpointUrl(SERVICE_API.recordScenario);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async getMRPCatalogs(data) {
        const url = this.getEndpointUrl(SERVICE_API.getMRPCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getPeggingInformation(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPeggingInformation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getProductionItem(data) {
        const url = this.getEndpointUrl(SERVICE_API.getProductionItem);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateMRPDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateMRPDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getScenarios() {
        const url = this.getEndpointUrl(SERVICE_API.getScenarios);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getOrderRecommendation(data) {
        const url = this.getEndpointUrl(SERVICE_API.getOrderRecommendation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async chargeItemsByFilters(data) {
        const url = this.getEndpointUrl(SERVICE_API.chargeItemsByFilters);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateRecommendationTable(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateRecommendationTable);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async updateRecommendationType(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateRecommendationType);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async saveRecommendations(data) {
        const url = this.getEndpointUrl(SERVICE_API.saveRecommendations);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ arrRecomendations: data }),
            },
        );
        return response;
    }

    async startScenario(MsnCode) {
        const url = this.getEndpointUrl(SERVICE_API.startScenario);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ MsnCode: MsnCode }),
            },
        );
        return response;
    }

    async crateForecastV2(data) {
        const url = this.getEndpointUrl(SERVICE_API.crateForecastV2);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async startScenarioV2(model, previsiones) {
        const url = this.getEndpointUrl(SERVICE_API.startScenarioV2);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ model, previsiones }),
            },
        );
        return response;
    }

    async createMRPDocuments(items, ReleasDate, CardCode) {
        const url = this.getEndpointUrl(SERVICE_API.createMRPDocuments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items, ReleasDate, CardCode }),
            },
        );
        return response;
    }
    async createMRPGroup(recommendations) {
        const url = this.getEndpointUrl(SERVICE_API.createMRPGroup);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ recommendations }),
            },
        );
        return response;
    }

    //#endregion

    //#region #### SPECIAL PRICES ####

    async getProductSpecialPrice(CardCode, Time) {
        const url = this.getEndpointUrl(SERVICE_API.getProductSpecialPrice);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Time, CardCode }),
            },
        );
        return response;
    }

    async getScheduleSpecialPrice(type) {
        const url = this.getEndpointUrl(SERVICE_API.getScheduleSpecialPrice + '/' + type);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getPromosActive() {
        const url = this.getEndpointUrl(SERVICE_API.getPromosActive);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getAuthorizations() {
        const url = this.getEndpointUrl(SERVICE_API.getAuthorizations);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async savePromos(Promos, Authorizations) {
        const url = this.getEndpointUrl(SERVICE_API.savePromos);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Promos, Authorizations }),

            },
        );
        return response;
    }

    //#endregion #### SPECIAL PRICES ####

    //#region #### REFERRED SYSTEM ###################
    async validateExistReferredPartner(data) {
        let url = this.getEndpointUrl(SERVICE_API.validateExistReferredPartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async converToAmbassador(data) {
        let url = this.getEndpointUrl(SERVICE_API.converToAmbassador);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async converToReferred(data) {
        let url = this.getEndpointUrl(SERVICE_API.converToReferred);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async getPartnersRefSys(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getPartnersRefSys);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }


    async getReferredPartners(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getReferredPartners);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getAmbassadors(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getAmbassadors);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getReferSysPromo(filter) {
        const url = this.getEndpointUrl(SERVICE_API.getReferSysPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async createReferSysPromo(filter) {
        const url = this.getEndpointUrl(SERVICE_API.createReferSysPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async deleteReferSysPromo(filter) {
        const url = this.getEndpointUrl(SERVICE_API.deleteReferSysPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filter)
            },
        );
        return response;
    }

    async getDataNotifTab(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDataNotifTab);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async userOperationsNotifTab(data) {
        const url = this.getEndpointUrl(SERVICE_API.userOperationsNotifTab);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async cancelPaymentRequest(data) {
        const url = this.getEndpointUrl(SERVICE_API.cancelPaymentRequest);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion #### AMBASSADORS ################

    //#region #### SUGGEST REFILL ###################
    async createSuggestRefillItems(data) {
        const url = this.getEndpointUrl(SERVICE_API.createSuggestRefill);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSuggestRefillItems(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSuggestRefillItems);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSuggestItemsBySuc(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSuggestItemsBySuc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSuggestRefillDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.suggestRefillList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getSuggestFillDocDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.suggestRefillDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion #### SUGGEST REFILL ################

    //#region M-SUITE MANAGEMENT ###################
    async mVentasSaveUser(data) {
        const url = this.getEndpointUrl(SERVICE_API.mVentasSaveUser);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async mVentasListData(data) {
        const url = this.getEndpointUrl(SERVICE_API.mVentasListData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }
    async mVentasDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.mVentasDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data }),
            },
        );
        return response;
    }

    async mVentasGetModules() {
        const url = this.getEndpointUrl(SERVICE_API.mVentasGetModules);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }
    //#endregion


    //#region SETTINGS TASKS BOT
    async SaveTaskRule(data) {
        const url = this.getEndpointUrl(SERVICE_API.saveTaskRule);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async UpdateTaskRule(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateTaskRule);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async ExecuteTask(data) {
        const url = this.getEndpointUrl(SERVICE_API.executeTask);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GetTaskData(data) {
        const url = this.getEndpointUrl(SERVICE_API.getTaskData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async DeleteTask(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteTask);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async DeleteTaskLog(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteTaskLog);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async GetUsersForTask() {
        const url = this.getEndpointUrl(SERVICE_API.getUsersForTask);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            },
        );
        return response;
    }
    //#endregion

    async printDelivaryAcuse(data) {
        const url = this.getEndpointUrl(SERVICE_API.printDelivaryAcuse);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async printRoadmapPreview(data) {
        const url = this.getEndpointUrl(SERVICE_API.printRoadmapPreview);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async rePrintRoadMap(data) {
        const url = this.getEndpointUrl(SERVICE_API.rePrintRoadMap);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async printRoadmap(data) {
        const url = this.getEndpointUrl(SERVICE_API.printRoadmap);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteRoadMap(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteRoadMap);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    /**WHS ADMIN */
    async getListWareHouse(data) {
        const url = this.getEndpointUrl(SERVICE_API.getListWareHouse);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async getDetailsWareHouse(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDetailsWareHouse);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async wareHouseAction(data) {
        const url = this.getEndpointUrl(SERVICE_API.wareHouseAction);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    async listAccounts(data) {
        const url = this.getEndpointUrl(SERVICE_API.listAccounts);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    //#region InternalReconciliation
    async getReconciliationInvoices(CardCode) {
        let url = this.getEndpointUrl(SERVICE_API.getReconciliationInvoices + "/" + CardCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            },
        );
        return response;
    }

    async createReconciliation(data) {
        let url = this.getEndpointUrl(SERVICE_API.createReconciliation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#endregion InternalReconciliation

    async getClientListDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.getClientListDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );

        return response;
    }

    async getSuggestionsDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.getSuggestionsDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data }),
            },
        );

        return response;
    }
    //#region LISTA DE PRECIOS
    async CreateNewPriceList(data) {
        const url = this.getEndpointUrl(SERVICE_API.CreateNewPriceList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data })
            },
        );
        return response;
    }

    async getDetailsPriceList(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDetailsPriceList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    };

    async UpdatePriceList(data) {
        const url = this.getEndpointUrl(SERVICE_API.UpdatePriceList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data })
            },
        );
        return response;
    }

    async SearchItemsPL(data) {
        const url = this.getEndpointUrl(SERVICE_API.SearchItemsPL);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async UpdateItemPriceList(data) {
        const url = this.getEndpointUrl(SERVICE_API.UpdateItemPriceList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ data })
            },
        );
        return response;
    }
    //#endregion LISTA DE PRECIOS

    //#region ######### GRUPO DE ARTICULOS #########
    async getDataiInitialGroupCode(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDataiInitialGroupCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            },
        );
        return response;
    };

    async getItemsGroupCode(data) {
        const url = this.getEndpointUrl(SERVICE_API.getItemsGroupCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    };

    async getAdministrativeExpenses(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAdministrativeExpenses);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    };

    async CreateNewGroupCode(data) {
        const url = this.getEndpointUrl(SERVICE_API.CreateNewGroupCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data })
            },
        );
        return response;
    };

    async UpdateGroupCode(data) {
        const url = this.getEndpointUrl(SERVICE_API.UpdateGroupCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data })
            },
        );
        return response;
    }
    //#endregion ######### GRUPO DE ARTICULOS #########


    //#region ######### TIMBRADO DE NOMINAS #########
    async CreateNominaDoc(data) {
        const url = this.getEndpointUrl(SERVICE_API.createNominaDoc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetNominaDoc(data) {
        const url = this.getEndpointUrl(SERVICE_API.getNominaDoc);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetListNominas(data) {
        const url = this.getEndpointUrl(SERVICE_API.getListNominas);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async TimbraNominas(data) {
        const url = this.getEndpointUrl(SERVICE_API.timbraNominas);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetNominaInfoCatalogs(data) {
        const url = this.getEndpointUrl(SERVICE_API.nominasCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async DownloadNominaDocs(data) {
        let url = this.getEndpointUrl(SERVICE_API.downloadNominaDocs);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async GetListEmployeeNom(data) {
        const url = this.getEndpointUrl(SERVICE_API.employeeNomList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async CreateEmployeeNom(data) {
        const url = this.getEndpointUrl(SERVICE_API.employeeNomCreate);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async ReadEmployeeNom(data) {
        const url = this.getEndpointUrl(SERVICE_API.employeeNomRead);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#endregion ######### TIMBRADO DE NOMINAS #########

    //#region ######### OXXO SERVICES #########
    async GetInfoOxxoReference(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInfoReference);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }


    async GenerateOxxoRef(data) {
        const url = this.getEndpointUrl(SERVICE_API.generateOxxoRef);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#endregion #########  OXXO SERVICES #########


    //#region ######### SERVICIOS  #########
    async listGeolocalization(data) {
        const url = this.getEndpointUrl(SERVICE_API.listGeoLocalization);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }
    async listAssignedRoutes(data) {
        const url = this.getEndpointUrl(SERVICE_API.listAssignedRoutes);
        const response = await apiFetchWithSession(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }
    //#endregion #########SERVICIOS #########

    //#region ######### LLAMAGAS #########
    async validateRUC(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateRUC);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    };
    async validatePadron(data) {
        const url = this.getEndpointUrl(SERVICE_API.validatePadron);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    };
    async validateOSIN(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateOSIN);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            },
        );
        return response;
    };
    //#endregion ######### LLAMAGAS #########

    //#region ######### ATTACHMENTS #########    
    async uploadAttachmentFile(file) {
        const url = this.getEndpointUrl(SERVICE_API.uploadAttachmentFile);
        const formData = new FormData();
        formData.append('file', file);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                body: formData
            }
        );
        return response;
    }

    async downloadAttachmentFile(data) {
        let url = this.getEndpointUrl(SERVICE_API.downloadAttachmentFile);
        const response = await apiFetchWithSessionFiles(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateAttachments(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateAttachments);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }

    async UpdateAttachment(data) {
        const url = this.getEndpointUrl(SERVICE_API.UpdateAttachment);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                },
                body: data
            },
        );
        return response;
    }

    async SaveFileOV(data) {
        const url = this.getEndpointUrl(SERVICE_API.SaveFileOV);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                },
                body: data
            },
        );
        return response;
    }
    //#endregion ######### ATTACHMENTS #########

    //#region ######### LLAMAGAS #########
    async getFiseInfoByCode(code, cardCode) {
        const url = this.getEndpointUrl(SERVICE_API.getFiseInfoByCode + '/' + (code || '--') + '/' + (cardCode || '--'));

        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            }
        );
        return response;
    }

    async listFiseCodes(search) {
        const url = this.getEndpointUrl(SERVICE_API.listFiseCodes);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(search)
            }
        );
        return response;
    }

    async getPriceListLlama(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPriceListLlama);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }

    async getHistoricalPriceListLlama(data) {
        const url = this.getEndpointUrl(SERVICE_API.getHistoricalPriceListLlama);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### LLAMAGAS #########

    //#region ############ SCOP CODE #########    
    async ValidateScopCode(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateScopCode);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### SCOP CODE #########

    //#region ######### NIUBIZ #########
    async generateNiubizQR(data) {
        const url = this.getEndpointUrl(SERVICE_API.generateNiubizQR);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### NIUBIZ #########
    async getLocations(searchLocation, page = null, itemsPage = null, ToWhsCode = null) {

        const url = this.getEndpointUrl(SERVICE_API.getLocations);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    searchLocation: searchLocation,
                    page,
                    itemsPage,
                    ToWhsCode: ToWhsCode,
                })
            },
        );
        return response;
    }

    async getLocation(AbsEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getLocation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ AbsEntry })
            },
        );
        return response;
    }

    //#region ######### SERIES AND CONSECUTIVES #########
    async listDocTypeSeries(data) {
        const url = this.getEndpointUrl(SERVICE_API.listDocTypeSeries);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }

    async getBPData(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBPData);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### SERIES AND CONSECUTIVES #########

    async getTaxWithholdingCatalog(type) {
        const url = this.getEndpointUrl(SERVICE_API.getTaxWithholdingCatalog + type);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            },
        );
        return response;
    }

    async getUomCodeList(itemCode) {
        const url = this.getEndpointUrl(SERVICE_API.getUomCodeList + "/" + itemCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    //#region ######### GLACCOUNTS #########
    async getGLAccounts(data) {
        const url = this.getEndpointUrl(SERVICE_API.getGLAccounts);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### GLACCOUNTS #########

    //#region ######### TRANSPORTS #########
    async getBinLocationBySucursal(data) {
        const url = this.getEndpointUrl(SERVICE_API.getBinLocationBySucursal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async transportData(data) {
        const url = this.getEndpointUrl(SERVICE_API.transportData);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async getTransportSeries(data) {
        const url = this.getEndpointUrl(SERVICE_API.getTransportSeries);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion ######### TRANSPORTS #########

    //#region ######### GALLONS CONVERSION #########
    async getGallonsConversion(item) {
        const url = this.getEndpointUrl(SERVICE_API.getGallonsConversion);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(item),
            }
        );
        return response;
    }
    async getFactorConversion(data) {
        const url = this.getEndpointUrl(SERVICE_API.getFactorConversion);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### GALLONS CONVERSION #########

    //#region ######### DIMENSIONS #########
    async getDimensions(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDimensions);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### DIMENSIONS #########

    //#region ######### RATE #########
    async convertAmount(data) {
        const url = this.getEndpointUrl(SERVICE_API.convertAmount);

        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
        return response;
    }
    //#endregion ######### RATE #########
    //#region ######### CANALIZADOS #########
    async listTanques(data) {
        const url = this.getEndpointUrl(SERVICE_API.listTanques);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    async loadCatalogsTanque() {
        const url = this.getEndpointUrl(SERVICE_API.loadCatalogsTanque);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            },
        );
        return response;
    }
    //#endregion ######### CANALIZADOS #########

    async reProcessCU(data) {
        const url = this.getEndpointUrl(SERVICE_API.reProcessCU);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async resumeTransports(data) {
        const url = this.getEndpointUrl(SERVICE_API.resumeTransports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async transportCatalogs(data) {
        const url = this.getEndpointUrl(SERVICE_API.transportCatalogs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async detailsResume(data) {
        const url = this.getEndpointUrl(SERVICE_API.detailsResume);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async generateRoadMapT(data) {
        const url = this.getEndpointUrl(SERVICE_API.generateRoadMap);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async prepareSunatGuide(data) {
        const url = this.getEndpointUrl(SERVICE_API.prepareSunatGuide);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#region CREDIT PERCEPTIONS
    async perceptionJournalEntries(data) {
        const url = this.getEndpointUrl(SERVICE_API.perceptionJournalEntries);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion CREDIT PERCEPTIONS

    //#region CESION USO CONTADO
    async validateCUso(data) {
        const url = this.getEndpointUrl(SERVICE_API.validateCUso);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion CESION USO CONTADO

    async getFormattedQueries(data) {
        const url = this.getEndpointUrl(SERVICE_API.getFormattedQueries);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getFormattedQueriesByCUFD(data) {
        const url = this.getEndpointUrl(SERVICE_API.getFormattedQueriesByCUFD);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async collectPayments(data) {
        const url = this.getEndpointUrl(SERVICE_API.collectPayments);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async reabsResumeDetails(data) {
        const url = this.getEndpointUrl(SERVICE_API.reabsResumeDetails);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async reabsResume(data) {
        const url = this.getEndpointUrl(SERVICE_API.reabsResume);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async cutTransferOperation(data) {
        const url = this.getEndpointUrl(SERVICE_API.cutTransferOperation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getUbigeoByZipCode(data) {
        const url = this.getEndpointUrl(SERVICE_API.getUbigeoByZipCode);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getDepartamentoByProvincia(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDepartamentoByProvincia);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#region REPROCESS ADMIN
    async listDocsMVentas(data) {
        const url = this.getEndpointUrl(SERVICE_API.listDocsMVentas);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion REPROCESS ADMIN

    async checkCreditOperations(data) {
        const url = this.getEndpointUrl(SERVICE_API.checkCreditOperations);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async approveCashCutMVENTAS(data) {
        const url = this.getEndpointUrl(SERVICE_API.approveCashCutMVENTAS);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    //#region Flujo de caja
    async getOCFW(data) {
        const url = this.getEndpointUrl(SERVICE_API.getOCFW);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async accountInfo(data) {
        const url = this.getEndpointUrl(SERVICE_API.accountInfo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    //#endregion Flujo de caja

    async printCesionEnUsoDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.printCesionEnUsoDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async printGREDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.printGREDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async printTicketDocs(data) {
        const url = this.getEndpointUrl(SERVICE_API.printTicketDocs);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getORDRTransports(data) {
        const url = this.getEndpointUrl(SERVICE_API.getORDRTransports);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    //#region Cuenta de mayor para OIGN y OIGE
    async getInventoryAccount(data) {
        const url = this.getEndpointUrl(SERVICE_API.getInventoryAccount);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            },
        );
        return response;
    }
    //#endregion Cuenta de mayor para OIGN y OIGE

    //#region ######### Standard REQUEST #########
    async get(endpoint, params) {
        const url = this.getEndpointUrl(`${SERVICE_API[endpoint]}${(params ? `/${Array.isArray(params) ? params.join("/") : params}` : "")}`);
        return await apiFetchWithSession(url, { method: "GET" });
    }

    async post(endpoint, data, params) {
        const url = this.getEndpointUrl(`${SERVICE_API[endpoint]}${(params ? `/${Array.isArray(params) ? params.join("/") : params}` : "")}`);
        return await apiFetchWithSession(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
    }
    //#endregion ######### Standard REQUEST #########
}

export function createApiClient(baseUrl) {
    return new ApiClient(baseUrl);
}

async function apiFetchFiles(url, init) {
    try {
        const rawResponse = await fetch(url, init);

        const response = await rawResponse;

        evaluateSessionExpiredResponse(response);

        return response;
    } catch (e) {
        return {
            status: 0,
            message: 'Ocurrió un error inesperado, por favor intente más tarde',
        };
    }
}

function validateRequestSize(request) {
    try {
        const jsonString = JSON.stringify(request);
        const byteSize = new TextEncoder().encode(jsonString).length;
        if (byteSize > MAX_REQUEST_SIZE) return false;
        return true;
    } catch (error) {
        console.error('Error al calcular el tamaño del objeto:', error);
        return false;
    }
}

async function apiFetch(url, init) {
    let stopRequestMonitor = null;
    try {

        // const rawResponse = await fetch(url, init);
        // const response = await rawResponse.json();
        // evaluateSessionExpiredResponse(response);
        // return response;
        if (!validateRequestSize(init)) {
            return {
                status: 0,
                message: 'Limite excedido, por favor elimine uno o más artículos y vuelva a intentarlo',
                data: [],
            };
        }

        stopRequestMonitor = startLongRequestMonitor(); // Start Request monit
        return await fetch(url, init)
            .then(async (response) => {
                return await response.json()
            })
            .catch(() => {
                return {
                    status: 0,
                    message: 'Ocurrió un error inesperado, por favor intente más tarde',
                    data: [],
                };
            });

    } catch (e) {
        return {
            status: 0,
            message: 'Ocurrió un error inesperado, por favor intente más tarde',
            data: [],
        };
    } finally {
        if (stopRequestMonitor) { stopRequestMonitor(); } // Stop request monit
    }
}

async function apiFetchWithSessionFiles(url, init, optionalToken = undefined) {
    let token;

    if (!optionalToken) {
        token = await ApiClient.getSessionToken();
    } else {
        token = optionalToken;
    }

    if (!token) {
        const response = {
            status: -10,
            message: 'No hay una sesión activa',
            data: [],
        };

        evaluateSessionExpiredResponse(response);

        return response;
    }

    if (init) {
        init.headers = {
            ...init.headers,
            Authorization: token,
        };
    }

    return apiFetchFiles(url, init);
}

async function apiFetchWithSession(url, init, optionalToken = undefined) {
    let token;

    if (!optionalToken) {
        token = await ApiClient.getSessionToken();
    } else {
        token = optionalToken;
    }

    if (!token) {
        const response = {
            status: -10,
            message: 'No hay una sesión activa',
            data: [],
        };

        evaluateSessionExpiredResponse(response);

        return response;
    }

    if (init) {
        init.headers = {
            ...init.headers,
            Authorization: token,
        };
    }

    const responseFetch = await apiFetch(url, init);
    // Evalua el estatus de la respuesta del back
    return validateResponseFetch(responseFetch);
}

function evaluateSessionExpiredResponse(response) {
    if (response.status < 0) {
        if (ApiClient.sessionExpiredCallback) {
            ApiClient.sessionExpiredCallback(response);
        }
    }
}

function validateResponseFetch(response) {
    if (response.status === -99) {
        setTimeout(() => {
            socketService.emit('logout', ''); // Para que el socket de notificaciones lo borre de sus usuarios logueados 
            localStorage.clear();
            localStorage.setItem(config.localStorageNamed + 'tokenExpired', '1'); // Reconocer que la sesion expiro 
            window.location.href = window.location.origin;
        }, 1000);
        return {
            status: 0,
            data: [],
            message: 'Su sesion ha expirado'
        };
    }

    return response;
}

function startLongRequestMonitor() {
    const interval = setInterval(() => {
        const notificationReducer = store.getState().NotificationReducer;
        const showAlert = notificationReducer?.showAlert;

        if (typeof showAlert === "function") {
            showAlert({ type: "info", message: "NO CIERRE NI RECARGUE SU PÁGINA, seguimos procesando su petición" });
        }
    }, REQUEST_WARNING_INTERVAL);

    return () => { clearInterval(interval); };
}
